export default "__VITE_ASSET__CyVb11Jr__"